import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OrderStateService } from '../../order/services/order-state.service';

@Injectable()
export class PaymentCompleteGuard implements CanActivate {

  constructor(
    private router: Router,
    private orderStateService: OrderStateService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.orderStateService.order) {
      return true;
    }

    this.router.navigateByUrl('/');

    return false;
  }
}
